import { createContext } from 'react'

// Share contact updates so the profile, badges and user actions stay in sync.
export const TechnicalPrimaryContext = createContext(null)
export const REPLACEMENT_REQUIRED = 'technical_primary_replacement_required'
// System Users opens Add System User with Technical Primary selected when this search parameter is 'true'.
export const ADD_AS_TECHNICAL_PRIMARY_PARAM = 'technicalPrimary'
